import { CustomerSales } from '../translations-types';

const translations: CustomerSales = {
  title: 'Verkopen',
  date: 'Datum',
  order: 'Order',
  type: 'Type',
  description: 'Omschrijving',
  employee: 'Medewerker',
  quantity: 'Aantal',
  discount: 'Korting',
  total: 'Totaal',
  sum: 'Totaal',
  subtotal: 'Subtotaal',
  service: 'Dienst',
  product: 'Product',
  all: 'Alles',
  services: 'Diensten',
  products: 'Producten',
  noSales: 'Nog geen verkopen',
};

export default translations;
